import React, { useState, useEffect } from "react";
import {
    getProgramListByEmployer, getProgramList, getProgramListByPartner, getCandidateListByProgramId, getS3PresignedUrl,
    uploadDocumentBucket, getProjectAttendanceByProgramId, downloadDocumentBucket,
    createBulkCandidateAttendance, getCandidateAttendanceByProgramId, createProjectAttendanceByAdmin, 
    updateProjectAttendanceByAdmin, trainingCompleteCall
} from "lib/axiosUtils";
import { LOADING_SPIN, PICTURE_ICON, IMPORT_ICON, CLOCK } from "assets/constants/Icons";
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL, UPLOAD_DAILY_PHOTO_ROWS, SUPER_ADMIN, ADMIN } from "assets/constants/Constants";
import Spinner from 'components/Spinner';
import Select from 'react-select';
import ShowToast from 'components/ShowToast';
import { fetchMetadata } from "lib/utils";
import Toast from "light-toast";
import HolidayReasonPopup from "components/HolidayReasonPopup";

const AttendanceModulePage = () => {
    const [projectListData, setProjectListData] = useState([]);
    const [loadingComplete, setLoadingComplete] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [projectListComponent, setProjectListComponent] = useState([]);
    const [candidateList, setCandidateList] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [weekComponentList, setWeekComponentList] = useState([]);
    const [error, setError] = useState({});
    const [metaData, setMetaData] = useState(JSON.parse(localStorage.getItem("metadata")) ? JSON.parse(localStorage.getItem("metadata")) : []);
    const [totalWeeks, setTotalWeeks] = useState([]);
    const [selectedWeekDates, setSelectedWeekDates] = useState([]);
    const [attendanceTypeComponent, setAttendanceTypeComponent] = useState([]);
    const [uploadDailyPhotos, setUploadDailyPhotos] = useState([]);
    const [selectedProjectAttendance, setSelectedProjectAttendance] = useState({});
    const [selectedCandidateAttedance, setSelectedCandidateAttendance] = useState([]);
    const [originalCandidateList, setOriginalCandidateList] = useState([]);
    const [disableSelectWeek, setDisableSelectWeek] = useState(true);
    const [todayDate, setTodayDate] = useState("")
    const [updateDateAllowed, setUpdateDateAllowed] = useState([]);
    const hiddenFileInput = React.createRef();
    const [userData] = useState(localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null);
    const [adminProfileFlag] = useState((userData && userData.user_role && (userData.user_role.replace(" ", "") === "superadmin" || userData.user_role.replace(" ", "") === "admin")) ? true : false);
    const [selectedProjectData, setSelectedProjectData] = useState({});
    const [hideSubmitButton, setHideSubmitButton] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [batchList, setBatchList] = useState([]);
    const [batchElementDisabled, setBatchElementDisabled] = useState(true);
    const [partnerListComponent, setPartnerListComponent] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState([])
    const [selectedPartnerId, setSelectedPartnerId] = useState(userData?.partner_id || "");
    const [afterSubmitClick, setAfterSubmitClick] = useState(false);
    const [showHolidayReasonPopup, setShowHolidayReasonPopup] = useState(false);
    const [currentDate, setCurrentDate] = useState(null);
    const [attendanceRows, setAttendanceRows] = useState([]);
    const [isCandidateLoading, setIsCandidateLoading] = useState(false);
    const [trainingCompleteLoading, setTrainingCompleteLoading] = useState(false);
    const [trainingCompleteButton, setTrainingCompleteButton] = useState("Training Complete");

    useEffect(() => {
        fetchProjectList();
    }, []);

    const fetchProjectList = async () => {
        try {
            const userDetail = JSON.parse(localStorage.getItem("userData"));
            let response;
            if (userDetail?.employer_id) {
                response = await getProgramListByEmployer({}, {}, userDetail.employer_id);
            } else if (userDetail?.partner_id) {
                response = await getProgramListByPartner({}, {}, userDetail.partner_id);
            } else {
                response = await getProgramList({}, {});
            }

            const projectComponentList = response.data.result.map((item) => {
                return ({ label: item.program_name, value: item._id });
            });
            setProjectListComponent(projectComponentList);
            setProjectListData(response.data.result);
        } catch (error) {
            console.error("Error while fetching Partner Data:", error);
        } finally {
            setLoadingComplete(true);
        }
    };

    useEffect(() => {
        const fetchMetaDataResult = async () => {
            if (metaData && metaData.length === 0) {
                const metaResult = await fetchMetadata();
                setMetaData(metaResult);
            }
        }
        fetchMetaDataResult();
    }, [metaData]);

    const fetchProjectAttendanceWhenTheDataisSubmitted = async () => {
        try {
            if (selectedProgram) {
                setAfterSubmitClick(!afterSubmitClick);
                // const fetchPromises = [
                //     getProjectAttendanceByProgramId({}, {}, selectedProgram.value),
                //     getCandidateAttendanceByProgramId({}, {}, selectedProgram.value)
                // ];
                // const [projectAttendanceData, candidateAttendanceData] = await Promise.all(fetchPromises);
                // setSelectedProjectAttendance(projectAttendanceData.data.result[0] ? projectAttendanceData.data.result[0] : {});
                // setSelectedCandidateAttendance(candidateAttendanceData.data.result);
            }
        }
        catch (error) {
            console.log("Error occurred while fetching the project attendance", error);
        }
    }

    const flattenProjectAttendanceByWeek = (attendanceData, selectedWeekKey, selectedWeekDates) => {
        const result = [];

        if (!attendanceData?.partners || !Array.isArray(selectedWeekDates)) return result;

        // Build a dateMap: date => { partner_id => { batch_number => { photo_url, loading } } }
        const dateMap = {};

        attendanceData.partners.forEach(partner => {
            const partnerId = partner.partner_id;

            partner.batches.forEach(batch => {
                const batchNumber = batch.batch_number;
                const weekArray = batch[selectedWeekKey]; // e.g., week_2

                if (Array.isArray(weekArray)) {
                    weekArray.forEach((day) => {
                        if (!day?.date) return;

                        if (!dateMap[day.date]) {
                            dateMap[day.date] = {};
                        }

                        if (!dateMap[day.date][partnerId]) {
                            dateMap[day.date][partnerId] = {};
                        }

                        dateMap[day.date][partnerId][batchNumber] = {
                            photo_url: day.photo_url || "",
                            loading: day.loading || false,
                            holiday_reason: day.holiday_reason || ""
                        };
                    });
                }
            });
        });

        // Now build the exact 7-day structure from selectedWeekDates
        selectedWeekDates.forEach(date => {
            const attendanceEntries = [];

            if (dateMap[date]) {
                Object.entries(dateMap[date]).forEach(([partnerId, batchData]) => {
                    const batches = Object.entries(batchData).map(([batchNumber, values]) => ({
                        batch: Number(batchNumber),
                        photo_url: values.photo_url,
                        loading: values.loading,
                        holiday_reason: values.holiday_reason
                    }));

                    attendanceEntries.push({
                        partner_id: partnerId,
                        batch: batches
                    });
                });
            }

            result.push({
                date,
                attendance_photo_url: attendanceEntries,
            });
        });

        return result;
    };


    useEffect(() => {
        const normalizeAttendanceData = (attendanceData) => {
            const grouped = {};

            attendanceData.forEach(item => {
                const partnerId = item.partner_id;
                const batchList = Array.isArray(item.batch) ? item.batch : [];

                if (!grouped[partnerId]) {
                    grouped[partnerId] = [];
                }

                batchList.forEach(b => {
                    grouped[partnerId].push({
                        batch: Number(b.batch),
                        photo_url: b.photo_url || "",
                        loading: !!b.loading,
                        holiday_reason: b.holiday_reason || ""
                    });
                });
            });

            return Object.entries(grouped).map(([partnerId, batch]) => ({
                partner_id: partnerId,
                batch
            }));
        };

        const generateEmptyWeekStructure = () => {
            return selectedWeekDates.map((date) => ({
                date,
                attendance_photo_url: selectedProjectData.partner_id.map(partnerId => ({
                    partner_id: partnerId,
                    batch: selectedBatch ? [{
                        batch: Number(selectedBatch.value),
                        photo_url: "",
                        loading: false,
                        holiday_reason:""
                    }] : []
                })),
                disabled: false,
                loading: false
            }));
        };

        if (!selectedWeek || !selectedBatch) return;

        const weekKey = selectedWeek?.value.replace("-", "_");
        const weekData = flattenProjectAttendanceByWeek(selectedProjectAttendance, weekKey, selectedWeekDates);

        // Case 1: No backend data for selected week
        if (!Array.isArray(weekData) || weekData.length === 0) {
            const emptyWeek = generateEmptyWeekStructure();
            const disabledStatus = getDisabledStatusforAlreadyPresentData(emptyWeek, true);
            setUploadDailyPhotos([{ dateArray: disabledStatus }]);
            return;
        }

        // Case 2: Normalize and merge backend data
        const normalizedWeekData = weekData.map((dateItem) => {
            const attendance = normalizeAttendanceData(dateItem.attendance_photo_url || []);

            // Ensure all partners exist
            selectedProjectData.partner_id.forEach(partnerId => {
                if (!attendance.find(p => p.partner_id === partnerId)) {
                    attendance.push({
                        partner_id: partnerId,
                        batch: selectedBatch ? [{
                            batch: Number(selectedBatch.value),
                            photo_url: "",
                            loading: false,
                            holiday_reason:""
                        }] : []
                    });
                }
            });

            return {
                date: dateItem.date,
                attendance_photo_url: attendance,
                disabled: false,
                loading: false
            };
        });
        const disabledStatus = getDisabledStatusforAlreadyPresentData(normalizedWeekData, true);

        setUploadDailyPhotos([{ dateArray: disabledStatus }]);
        // eslint-disable-next-line
    }, [selectedProjectAttendance, selectedWeek, selectedWeekDates, selectedBatch, selectedProjectData.partner_id]);

    const calculatePresentCount = (date) => {
        let presentCount = 0;
        candidateList.forEach((candidateItem) => {
            if (candidateItem.dateArray && candidateItem.dateArray.length > 0) {
                candidateItem.dateArray.forEach((item) => {
                    if (item.date === date && item.selectedDate && item.selectedDate.value === "present") {
                        presentCount++;
                    }
                })
            }
        })
        return presentCount;
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (selectedProgram && selectedBatch) {
                    setLoadingComplete(false);
                    setIsCandidateLoading(true);
                    const fetchPromises = [
                        getCandidateListByProgramId({}, {}, selectedProgram.value, selectedPartnerId),
                        getProjectAttendanceByProgramId({}, {}, selectedProgram.value),
                        getCandidateAttendanceByProgramId({}, {}, selectedProgram.value)
                    ];

                    const [candidateListData, projectAttendanceData, candidateAttendanceData] = await Promise.all(fetchPromises);
                    if (selectedBatch && selectedPartnerId) {
                        candidateListData.data.result = candidateListData.data.result.filter((item) => item.batch === selectedBatch.value && item.partner_id === selectedPartnerId);
                        setCandidateList(candidateListData.data.result);
                        setSelectedCandidateAttendance(candidateAttendanceData.data.result);
                        setOriginalCandidateList(candidateListData.data.result)
                        setSelectedProjectAttendance(projectAttendanceData.data.result[0] ? projectAttendanceData.data.result[0] : {});

                        const checkPartner = selectedProjectData.partner_batch_data.find((item) => item.partner_id === selectedPartnerId);
                        const getBatch = checkPartner.training_batches.find((findBatch) => findBatch.batch === selectedBatch.value)
                        if (getBatch) {
                            const futureDates = calculateWeeklyDates(getBatch.start_training_date, 9);
                            setTotalWeeks(futureDates);
                            setPredefinedWeekForTodaysDate(futureDates)
                        }

                        setLoadingComplete(true);
                        setIsCandidateLoading(false);
                        if (candidateListData?.data?.result.length === 0) {
                            ShowToast('No candidate in project', TYPE_FAIL, INTERVAL, null, "");
                            setDisableSelectWeek(true);
                        }
                    }
                }
            } catch (error) {
                console.log("Error occurred while fetching data", error);
                setLoadingComplete(true);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, [selectedBatch, afterSubmitClick]);

    useEffect(() => {
        async function fetchData() {
            const selectedProgramData = projectListData.find((findItem) => findItem._id === selectedProgram?.value);
            if (selectedPartnerId) {
                if (selectedProgramData?.partner_batch_data && selectedProgramData.partner_batch_data.length > 0) {
                    const partnerBatchData = selectedProgramData.partner_batch_data.find((item) => item.partner_id === selectedPartnerId);
                    if (partnerBatchData && partnerBatchData.training_batches && partnerBatchData.training_batches.length > 0) {
                        const batchListComponent = partnerBatchData.training_batches.map((batchItem) => {
                            return {
                                label: `Batch ${batchItem.batch}`,
                                value: batchItem.batch
                            };
                        })

                        setBatchList(batchListComponent);

                        // If only one batch, set it as selected
                        if (batchListComponent.length === 1 && (selectedPartner || !adminProfileFlag)) {
                            setSelectedBatch(batchListComponent[0]);
                            setDisableSelectWeek(false);
                        }
                    }
                }
            }

            if (adminProfileFlag) {
                const partnerList = selectedProgramData?.partnerItem.map((item) => {
                    return {
                        label: item.training_partner,
                        value: item._id
                    }
                })
                setPartnerListComponent(partnerList)
            }
        }
        fetchData();
    }, [selectedProgram, selectedPartner, adminProfileFlag, projectListData, selectedPartnerId]);

    const setPredefinedWeekForTodaysDate = (totalWeeksParam) => {
        let foundKey = null;
        let lastKey = null;
        for (let key in totalWeeksParam) {
            if (foundKey === null) {
                const findWeek = totalWeeksParam[key].find((findItem => findItem === todayDate));
                if (findWeek) {
                    foundKey = key;
                    setSelectedWeek({ label: capitalize(key), value: key })
                }
                lastKey = key;
            }
        }
        if (foundKey) {
            setSelectedWeekDates(totalWeeksParam[foundKey]);
        }
        else {
            setSelectedWeek({ label: capitalize(lastKey), value: lastKey })
            setSelectedWeekDates(totalWeeksParam[lastKey]);
        }
    }

    useEffect(() => {
        const todaysDate = getTodaysFormattedDate();
        setTodayDate(todaysDate);
    }, [])

    useEffect(() => {
        const getPreviousDates = () => {
            const today = new Date();
            const yesterday = new Date(today);
            const dayBeforeYesterday = new Date(today);

            yesterday.setDate(today.getDate() - 1);
            dayBeforeYesterday.setDate(today.getDate() - 2);

            return {
                dayBeforeYesterday: getPreviousFormattedDate(dayBeforeYesterday),
                yesterday: getPreviousFormattedDate(yesterday),
            };
        };

        if (Object.entries(totalWeeks).length > 0) {
            let allowedDates = [];
            const allDates = Object.values(totalWeeks).flat();
            const foundTodayDateIndex = allDates.findIndex((findItem) => findItem === todayDate);
            if (foundTodayDateIndex !== -1) {
                if (foundTodayDateIndex >= 2) {
                    allowedDates.push(allDates[foundTodayDateIndex]);
                    allowedDates.push(allDates[foundTodayDateIndex - 1]);
                    allowedDates.push(allDates[foundTodayDateIndex - 2]);
                }
                if (foundTodayDateIndex === 1) {
                    allowedDates.push(allDates[foundTodayDateIndex]);
                    allowedDates.push(allDates[foundTodayDateIndex - 1]);
                }
                if (foundTodayDateIndex === 0) {
                    allowedDates.push(allDates[foundTodayDateIndex]);
                }
                setHideSubmitButton(false);
            }
            else {
                const { yesterday, dayBeforeYesterday } = getPreviousDates();
                const foundYesterdayDateIndex = allDates.findIndex((findItem) => findItem === yesterday);
                if (foundYesterdayDateIndex !== -1) {
                    allowedDates.push(allDates[foundYesterdayDateIndex]);
                    allowedDates.push(allDates[foundYesterdayDateIndex - 1])
                }
                else {
                    const foundDayBeforeYesterdayDateIndex = allDates.findIndex((findItem) => findItem === dayBeforeYesterday);
                    if (foundDayBeforeYesterdayDateIndex !== -1) {
                        allowedDates.push(allDates[foundDayBeforeYesterdayDateIndex]);
                    }
                    else {
                        if (!adminProfileFlag) {
                            setHideSubmitButton(true);
                        }
                        else {
                            setHideSubmitButton(false);
                        }
                    }
                }
            }
            setUpdateDateAllowed(allowedDates);
        }

    }, [totalWeeks, todayDate, adminProfileFlag])


    const getTodaysFormattedDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getPreviousFormattedDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    const changeProjectName = (event) => {
        if (selectedProgram && selectedProgram.value === event.value) {
            return;
        }
        setSelectedBatch(null);
        setSelectedProgram(event);
        setSelectedWeek(null);
        setSelectedWeekDates([]);
        setUploadDailyPhotos([]);
        setSelectedPartner(null);
        setBatchList([]);

        if (event) {
            const startingDate = projectListData.find((findItem) => findItem._id === event.value);
            setSelectedProjectData(startingDate);
            setBatchElementDisabled(false);
        }
    }

    const calculateWeeklyDates = (startDate, weeks) => {
        const result = {};
        let date = new Date(startDate);

        for (let week = 1; week <= weeks; week++) {
            const weekDates = [];

            for (let day = 0; day < 7; day++) {
                // Format date as DD/MM/YY
                const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, "/");
                weekDates.push(formattedDate);

                // Move to the next day
                date.setDate(date.getDate() + 1);
            }

            result[`week-${week}`] = weekDates;
        }

        return result;
    }

    useEffect(() => {
        if (metaData.length > 0 && metaData[0].meta_data && metaData[0].meta_data.attendance_week_list.length > 0) {
            let weekListComponent = metaData[0].meta_data.attendance_week_list.map((item) => {
                return ({ label: item, value: item.toLowerCase() });
            })
            setWeekComponentList(weekListComponent);
            const attendanceTypeList = metaData[0].meta_data.attendance_type.map((item) => {
                return ({ label: item, value: item.toLowerCase() });
            })
            setAttendanceTypeComponent(attendanceTypeList)
        }
    }, [metaData])


    const changeWeekHandler = (event) => {
        setSelectedWeek(event);
        if ((selectedWeek && event.value !== selectedWeek.value) || !selectedWeek) {
            if (candidateList.length > 0) {
                setLoadingComplete(false);
            }
        }
        setSelectedWeekDates(totalWeeks[event.value]);
    }


    const capitalize = (s) => {
        return String(s[0]).toUpperCase() + String(s).slice(1);
    }

    const getAlreadyPresentDate = (dateItem) => {
        let returnObject = {};
        if (dateItem.status) {
            returnObject = { label: capitalize(dateItem.status), value: dateItem.status.toLowerCase() }
        }
        else {
            returnObject = null;
        }
        return returnObject;
    }

    const getDisabledStatusforAlreadyPresentData = (datesArray, addLoading = false) => {
        let tempArray = datesArray.map((dateItem) => {
            const findIfAllowedDates = updateDateAllowed.find((findItem) => findItem === dateItem.date);
            if (findIfAllowedDates) {
                if (!adminProfileFlag && dateItem.status) {
                    dateItem.disabled = true;
                } else {
                    dateItem.disabled = false;
                }
            }
            else {
                dateItem.disabled = adminProfileFlag ? false : true;
            }
            if (addLoading === true) {
                dateItem.loading = false;
            }
            return dateItem;
        })
        return tempArray;
    }

    const setIfEmptyWeekEntry = (candidateListArray) => {
        const tempCandidateList = candidateListArray.map((candidateItem, index) => {
            const tempArray = selectedWeekDates.map((item) => {
                let returnElement = {
                    date: item,
                    status: "",
                }
                return returnElement;
            })
            const disbaledStatus = getDisabledStatusforAlreadyPresentData(tempArray);
            let dateArray = disbaledStatus.map((dateItem) => {
                let currentDateObject = {
                    ...dateItem,
                    selectedDate: getAlreadyPresentDate(dateItem),
                }
                return currentDateObject;
            })
            let returnItem = {
                ...candidateItem,
                dateArray: dateArray
            };
            return returnItem;
        });
        setCandidateList(tempCandidateList);
    }

    const createAttendanceWeekForCandidate = (candidateItem, weekValue) => {
        const tempArray = selectedWeekDates.map((item) => {
            const returnObject = {
                date: item,
                status: ""
            }
            return returnObject
        })
        const disbaledStatus = getDisabledStatus(tempArray);
        return disbaledStatus;
    }

    const getDisabledStatus = (datesArray) => {
        let tempArray = datesArray.map((dateItem) => {
            const findIfAllowedDates = updateDateAllowed.find((findItem) => findItem === dateItem.date);
            if (findIfAllowedDates) {
                if (!adminProfileFlag && dateItem.status) {
                    dateItem.disabled = true;
                } else {
                    dateItem.disabled = false;
                }
            }
            else {
                dateItem.disabled = adminProfileFlag ? false : true;
            }
            return dateItem;
        })
        return tempArray;
    }

    useEffect(() => {
        if (selectedWeek && selectedWeekDates.length > 0 && originalCandidateList.length > 0 && selectedCandidateAttedance.length === 0) {
            setIfEmptyWeekEntry(originalCandidateList);
            setLoadingComplete(true);
        }
        if (selectedWeek && selectedWeekDates.length > 0 && originalCandidateList.length > 0 && selectedCandidateAttedance.length > 0) {
            const tempCandidateList = originalCandidateList.map((candidateItem) => {
                const attendancePresent = selectedCandidateAttedance.find((findItem) => findItem.candidate_id === candidateItem._id);
                let returnObject = {
                    ...candidateItem
                }
                if (attendancePresent) {
                    const tempArray = attendancePresent[selectedWeek.value.replace("-", "_")];
                    if (tempArray && tempArray.length > 0) {
                        const disbaledStatus = getDisabledStatusforAlreadyPresentData(tempArray);
                        let dateArray = disbaledStatus.map((dateItem) => {
                            let currentDateObject = {
                                ...dateItem,
                                selectedDate: getAlreadyPresentDate(dateItem),
                            }
                            return currentDateObject;
                        })
                        returnObject = {
                            ...returnObject,
                            dateArray: dateArray
                        }
                    }
                    else {
                        const disableStatus = createAttendanceWeekForCandidate(candidateItem, selectedWeek.value.replace("-", "_"));
                        let dateArray = disableStatus.map((dateItem) => {
                            let currentDateObject = {
                                ...dateItem,
                                selectedDate: getAlreadyPresentDate(dateItem),
                            }
                            return currentDateObject;
                        })
                        returnObject = {
                            ...returnObject,
                            dateArray: dateArray
                        }
                    }
                }
                else {
                    const disableStatus = createAttendanceWeekForCandidate(candidateItem, selectedWeek.value.replace("-", "_"));
                    let dateArray = disableStatus.map((dateItem) => {
                        let currentDateObject = {
                            ...dateItem,
                            selectedDate: getAlreadyPresentDate(dateItem),
                        }
                        return currentDateObject;
                    })
                    returnObject = {
                        ...returnObject,
                        dateArray: dateArray
                    }
                }
                return returnObject;
            })
            setCandidateList(tempCandidateList);
            setLoadingComplete(true);
        }
        // eslint-disable-next-line
    }, [selectedWeek, selectedWeekDates])

    const getColor = (value) => {
        switch (value) {
            case 'present': return '#b1dd8c';
            case 'absent': return '#FBB5AE';
            case 'leave': return '#FFF995';
            case 'holiday': return "#A3E4F4";
            default: return '#D6D6D6';
        }
    };

    const customStyles = (value) => ({
        control: (provided) => ({
            ...provided,
            backgroundColor: getColor(value),
            color: 'grey',
            borderColor: getColor(value),
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'grey',
        }),
        valueContainer: (provided) => ({
            ...provided,
            paddingRight: '20px',
        })
    });

    const getS3Key = (url) => {
        if (!url) return null;

        const s3UrlPattern = /^https:\/\/([^/]+)\.s3\.amazonaws\.com\/(.+)$/; // Match any S3 bucket URL
        const match = url.match(s3UrlPattern);

        if (match && match[2]) {
            return match[2];
        }

        return url;
    };

    const handleViewAttendancePhoto = async (event, url) => {
        event.preventDefault();
        const s3Key = getS3Key(url);

        if (!s3Key) {
            setError('Invalid file reference');
            return;
        }
        try {
            const response = await downloadDocumentBucket({}, { fileKey: s3Key });

            if (!response.data?.downloadUrl) {
                throw new Error('Invalid response from server');
            }

            window.open(response.data.downloadUrl, '_blank');
        } catch (err) {
            console.error('Download failed:', err);
            setError(err.message || 'Failed to generate download link');

            if (url.startsWith('http')) {
                window.open(url, '_blank');
            }
        } finally {
            // setIsLoading(false);
        }
    }

    const handleCandidatePresent = (event, date) => {
        event.preventDefault();
        const tempUploadPhoto = uploadDailyPhotos.map((presentItem, index) => {
            let returnObject = {
                ...presentItem
            }
            if (index === 1) {
                const findIndex = presentItem.dateArray.findIndex((findItem) => findItem.date === date);
                if (findIndex !== -1) {
                    returnObject = {
                        ...returnObject
                    }
                    if (userData && userData.partner_id) {
                        let candidatePresentData = returnObject.dateArray[findIndex].candidate_present;
                        let partnerIndex = null;
                        if (Array.isArray(candidatePresentData)) {
                            partnerIndex = candidatePresentData.findIndex((findItem) => findItem.partner_id === userData.partner_id);
                            if (partnerIndex !== null && partnerIndex !== -1) {
                                returnObject.dateArray[findIndex].candidate_present[partnerIndex].candidate_present = Number(event.target.value);
                            }
                            else {
                                returnObject.dateArray[findIndex].candidate_present.push({ partner_id: userData.partner_id, candidate_present: Number(event.target.value) });
                            }
                        }
                        else {
                            returnObject.dateArray[findIndex].candidate_present = [{ partner_id: userData.partner_id, candidate_present: Number(event.target.value) }];
                        }
                    }
                }
            }
            return returnObject;
        })
        setUploadDailyPhotos(tempUploadPhoto);
    }


    const handleAttendanceStatus = (event, currentDate, candidateId) => {
        if (event && event.value === "holiday") {
            handleMultipleAttendance(event, currentDate, "holiday");
        }
        else if (adminProfileFlag && event && event.value === "present") {
            handleMultipleAttendance(event, currentDate, "present");
        }
        else {
            const tempCandidateList = candidateList.map((candidateItem) => {
                let returnObject = {
                    ...candidateItem
                }
                if (candidateItem._id === candidateId && candidateItem.dateArray) {
                    let tempDateArray = [...candidateItem.dateArray];
                    const foundIndex = tempDateArray.findIndex((findItem) => findItem.date === currentDate);
                    if (foundIndex !== -1) {
                        tempDateArray[foundIndex].selectedDate = event;
                        tempDateArray[foundIndex].status = event.value;
                        returnObject = {
                            ...returnObject,
                            dateArray: tempDateArray
                        }
                    }
                }
                return returnObject;
            })
            
            setCandidateList(tempCandidateList);
        }
    }

     const cancelHandle = () =>{ 
        if(showHolidayReasonPopup === true){
            setShowHolidayReasonPopup(false);
        }
    }

    useEffect(() => {
        if (!uploadDailyPhotos?.length || !selectedPartnerId || !selectedBatch) {
            setAttendanceRows(UPLOAD_DAILY_PHOTO_ROWS);
            return;
        }

        try {
            let newRows = [...UPLOAD_DAILY_PHOTO_ROWS];

            const holidayReasonPresent = uploadDailyPhotos[0]?.dateArray?.some((dateItem) => {
                const partner = dateItem?.attendance_photo_url?.find(
                    (item) => item.partner_id === selectedPartnerId
                );

                return partner?.batch?.some(
                    (b) =>
                        b.holiday_reason &&
                        b.batch === selectedBatch.value
                );
            });

            if (holidayReasonPresent && !newRows.includes("Holiday Reason")) {
                newRows.push("Holiday Reason");
            }

            setAttendanceRows(newRows);
        } catch (error) {
            console.error("Error occurred while adding the row of holiday reason", error);
        }
    }, [uploadDailyPhotos, selectedPartnerId, selectedBatch]);



    

    const updateHolidayReason = (holidayReason) => {
        try{
            const tempArray = [...uploadDailyPhotos];
            const dateEntry = tempArray[0]?.dateArray?.find(item => item.date === currentDate);
            if (!dateEntry) return setUploadDailyPhotos(tempArray);
    
            const partnerEntry = dateEntry.attendance_photo_url?.find(
                item => item.partner_id === selectedPartnerId
            );
            if (!partnerEntry) return setUploadDailyPhotos(tempArray);
    
            const batchEntry = partnerEntry.batch?.find(
                item => item.batch === selectedBatch.value
            );
            if (!batchEntry) return setUploadDailyPhotos(tempArray);
    
            batchEntry.holiday_reason = holidayReason;
    
            setUploadDailyPhotos(tempArray);
        }
        catch(error){
            console.log("Error occurred while updating the holiday reason",error);
        }
    };

    const renderHolidayReason = (dateItem) => {
        let holidayReason = "";
        try {
            const findPartner = dateItem.attendance_photo_url.find((findItem) => findItem.partner_id === selectedPartnerId)
            if (findPartner) {
                const findBatch = findPartner.batch.find((findItem) => findItem.batch === selectedBatch?.value);
                if (findBatch) {
                    holidayReason = findBatch.holiday_reason;
                }
            }
        }
        catch (error) {
            console.log("Error occurred while rendering holiday reason", error);
        }
        return holidayReason
    }

    const handleMultipleAttendance = (event, currentDate, attendanceStatus) => {
        try {
            if (window.confirm(`On this date ${currentDate} ${attendanceStatus === "holiday" ? "Holiday" : "Present"} will be marked for Each and Every candidate. Are you sure you want to continue ?`)) {
                if (attendanceStatus === "holiday") {
                    setShowHolidayReasonPopup(true);
                    setCurrentDate(currentDate);
                }
                const tempCandidateList = candidateList.map((candidateItem) => {
                    let returnObject = {
                        ...candidateItem
                    }
                    let tempDateArray = [...candidateItem.dateArray];
                    const foundIndex = tempDateArray.findIndex((findItem) => findItem.date === currentDate);
                    if (foundIndex !== -1) {
                        tempDateArray[foundIndex].selectedDate = event;
                        tempDateArray[foundIndex].status = event.value;
                        returnObject = {
                            ...returnObject,
                            dateArray: tempDateArray
                        }
                    }
                    return returnObject;
                })
                setCandidateList(tempCandidateList)
            }

        }
        catch (error) {
            console.log("Error occurred while marking multiple attendance", error);
        }
    }

    const uploadAttendancePhotoForAdmin = async (event, currentItem, date) => {
        event.preventDefault();
        const files = event.target.files;
        if (files[0]) {
            Toast.loading("File is being uploaded, please wait...", 0);
            let error = {};
            if (files[0].size > 2000000) {
                error["uploadAttendancePhotoError"] = "The uploaded file size was more than 2 MB. Please upload a file which is less than 5MB.";
            }
            else {
                const batchNumber = Number(selectedBatch?.value);
                const tempLoadingPhotos = uploadDailyPhotos.map((item, index) => {
                    if (index !== 0) return item;
                    return {
                        ...item,
                        dateArray: item.dateArray.map(d => {
                            if (d.date !== date) return d;
                            const partnerIndex = d.attendance_photo_url.findIndex(
                                p => p.partner_id === currentItem._id
                            );

                            // Create updated attendance array
                            const updatedAttendance = [...d.attendance_photo_url];

                            if (partnerIndex !== -1) {
                                // Partner exists - update their batch
                                updatedAttendance[partnerIndex] = {
                                    ...updatedAttendance[partnerIndex],
                                    batch: [
                                        ...(updatedAttendance[partnerIndex].batch || []),
                                        {
                                            batch: batchNumber,
                                            photo_url: "",
                                            loading: true,
                                            holiday_reason: ""
                                        }
                                    ]
                                };
                            }

                            return {
                                ...d,
                                attendance_photo_url: updatedAttendance,
                                loading: true
                            };
                        })
                    };
                });

                setUploadDailyPhotos(tempLoadingPhotos);
                const file = files[0];
                try {
                    const response = await getS3PresignedUrl({}, {
                        fileName: file.name,
                        fileType: file.type,
                        programId: selectedProgram.value,
                        partnerId: selectedPartnerId,
                        batch: selectedBatch?.value,
                        selectedWeek: selectedWeek.value
                    });
                    const { url, fileUrl } = response.data;
                    const headers = {
                        "Content-Type": file.type,
                    };

                    await uploadDocumentBucket(headers, { url, file });
                    Toast.hide();
                    Toast.success("Photo uploaded successfully, Click to Submit", INTERVAL);

                    // Update state with the final URL
                    setUploadDailyPhotos(prev =>
                        prev.map((uploadItem, index) => {
                            return {
                                ...uploadItem,
                                dateArray: uploadItem.dateArray.map(dateEntry => {
                                    if (dateEntry.date !== date) return dateEntry;
                                    const updatedAttendanceList = (dateEntry.attendance_photo_url || []).map(p => {
                                        if (p.partner_id !== currentItem._id && p.partner_id !== currentItem.partner_id) {
                                            return p;
                                        }

                                        const batchArray = Array.isArray(p.batch) ? [...p.batch] : [];
                                        const batchIndex = batchArray.findIndex(b => b.batch === batchNumber);

                                        if (batchIndex !== -1) {
                                            batchArray[batchIndex] = {
                                                ...batchArray[batchIndex],
                                                photo_url: fileUrl,
                                                loading: false
                                            };
                                        } else {
                                            batchArray.push({
                                                batch: batchNumber,
                                                photo_url: fileUrl,
                                                loading: false
                                            });
                                        }

                                        return {
                                            ...p,
                                            batch: batchArray
                                        };
                                    });

                                    return {
                                        ...dateEntry,
                                        attendance_photo_url: updatedAttendanceList,
                                        loading: false,
                                        holiday_reason: ""
                                    };
                                })
                            };
                        })
                    );
                }
                catch (error) {
                    console.log("Error occurred while uploading the file:", error);
                    setUploadDailyPhotos(prev => prev.map((item, index) => {
                        if (index !== 0) return item;

                        return {
                            ...item,
                            dateArray: item.dateArray.map(d => {
                                if (d.date !== date) return d;

                                return {
                                    ...d,
                                    attendance_photo_url: d.attendance_photo_url.map(p => {
                                        if (p.partner_id !== currentItem._id) return p;

                                        return {
                                            ...p,
                                            batch: p.batch.filter(b => b.batch !== batchNumber),
                                            loading: false,
                                            holiday_reason:""
                                        };
                                    }),
                                    loading: false
                                };
                            })
                        };
                    }));
                }
            }
            setError(error);
        }
    }

    const validate = () => {
        let isValid = true;
        let error = {};
        if (!selectedProgram) {
            isValid = false;
            error.selectedProgram = "Please Select Project"
        }
        if (!selectedWeek) {
            isValid = false;
            error.selectedWeek = "Please Select Week";
        }
        setError(error);
        return isValid;
    }

    const checkIftheUpdateDataInAllowedDates = () => {
        let allowedUpdate = false;
        const filteredDates = selectedWeekDates.filter(date =>
            [updateDateAllowed[0], updateDateAllowed[1], updateDateAllowed[2]].includes(date)
        );
        if (filteredDates && filteredDates.length > 0) {
            allowedUpdate = true
        }
        return allowedUpdate;
    }

    const checkDataFilled = () => {
        let dataFilled = false;
        candidateList.forEach((candidateItem) => {
            const filteredDates = candidateItem.dateArray.filter(date =>
                [updateDateAllowed[0], updateDateAllowed[1], updateDateAllowed[2]].includes(date.date)
            );
            if (filteredDates && filteredDates.length > 0) {
                filteredDates.forEach((filteredItem) => {
                    if (filteredItem.selectedDate && dataFilled === false) {
                        dataFilled = true;
                    }
                })
            }
        })
        return dataFilled;
    }

    const handleSubmitClick = async () => {
        if (validate()) {
            if (checkIftheUpdateDataInAllowedDates() || adminProfileFlag) {
                if (checkDataFilled() || adminProfileFlag) {
                    setSubmitLoading(true);
                    try {
                        let filteredDates = [];
                        uploadDailyPhotos.forEach((item) => {
                            if (!adminProfileFlag) {
                                filteredDates = item.dateArray.filter(date =>
                                    [updateDateAllowed[0], updateDateAllowed[1], updateDateAllowed[2]].includes(date.date)
                                );
                            }
                            else {
                                filteredDates = [...item.dateArray];
                            }
                        })
                        filteredDates = filteredDates.map((item) => {
                            const returnElement = {
                                date: item.date,
                                attendance_photo_url: item.attendance_photo_url
                            }
                            return returnElement;
                        })
                        let projectAttendanceRequest = {
                            totalWeeks: totalWeeks,
                            [selectedWeek.value.replace("-", "_")]: [...filteredDates],
                            filteredDates: filteredDates,
                            programId: selectedProgram.value,
                            partnerId: userData.partner_id,
                            partnerIdArray: selectedProjectData.partner_id,
                            totalBatchCount: batchList.length,
                            partnerBatchData: selectedProjectData.partner_batch_data,
                            userId: (userData.user_role === SUPER_ADMIN || userData.user_role === ADMIN) ? userData._id : null,
                            selectedPartner: selectedPartner
                        };
                        const candidateAttendanceList = candidateList.map((candidateItem) => {
                            let filteredDates = null;
                            if (!adminProfileFlag) {
                                filteredDates = candidateItem.dateArray.filter(date =>
                                    [updateDateAllowed[0], updateDateAllowed[1], updateDateAllowed[2]].includes(date.date)
                                );
                            }
                            else {
                                filteredDates = [...candidateItem.dateArray];
                            }
                            let returnObject = {
                                program_id: selectedProgram.value,
                                candidate_id: candidateItem._id,
                                selectedBatch: selectedBatch ? selectedBatch.value : "",
                                [selectedWeek.value.replace("-", "_")]: filteredDates.map((item) => {
                                    let returnElement = {
                                        date: item.date,
                                        status: item.selectedDate && item.selectedDate.value ? item.selectedDate.value : "",
                                        recorded_by:  adminProfileFlag ? "admin" : userData && userData.partner_id ? "training_partner" : "",
                                        user_id: userData._id,
                                        in_time: item.in_time ? item.in_time : "09:00:00",
                                        out_time: item.out_time ? item.out_time : "18:00:00"
                                    }
                                    return returnElement;
                                })
                            }
                            return returnObject
                        })
                        let candidateAttendanceRequest = {
                            candidateAttendanceList: [...candidateAttendanceList],
                            programId: selectedProgram.value,
                            totalWeek: totalWeeks,
                            selectedWeek: selectedWeek.value,
                            selectedBatch: selectedBatch ? selectedBatch.value : "",
                            userId: (userData.user_role === SUPER_ADMIN || userData.user_role === ADMIN) ? userData._id : null,
                            selectedPartner: selectedPartner
                        }
                        const projectAttendancePromise = selectedProjectAttendance && selectedProjectAttendance._id
                            ? updateProjectAttendanceByAdmin({}, projectAttendanceRequest, selectedProjectAttendance._id)
                            : createProjectAttendanceByAdmin({}, projectAttendanceRequest)
                            
                        const candidateAttendancePromise = createBulkCandidateAttendance({}, candidateAttendanceRequest);

                        const [projectAttendanceResponse, candidateAttendanceResponse] = await Promise.all([
                            projectAttendancePromise,
                            candidateAttendancePromise
                        ]);

                        if (projectAttendanceResponse?.statusCode === 200 && candidateAttendanceResponse?.statusCode === 200) {
                            await fetchProjectAttendanceWhenTheDataisSubmitted();
                            ShowToast('Data submitted successfully', TYPE_SUCCESS, INTERVAL, null, "");

                        } else {
                            ShowToast('Data submission failed', TYPE_FAIL, INTERVAL, null, "");
                        }
                    }
                    catch (error) {
                        console.log("Error occurred while submitting data", error);
                    }
                    finally {
                        setSubmitLoading(false);
                    }
                }
                else {
                    ShowToast('Please select the attendance', TYPE_FAIL, INTERVAL, null, "");
                }
            }
            else {
                ShowToast('Not Allowed to submit this data', TYPE_FAIL, INTERVAL, null, "");
            }
        }
        else {
            ShowToast('Please enter required data', TYPE_FAIL, INTERVAL, null, "");
        }
    }

    const changeBatch = (event) => {
        const checkPartner = selectedProjectData.partner_batch_data.find((item) => item.partner_id === selectedPartnerId);
        const getBatch = checkPartner.training_batches.find((findBatch) => findBatch.batch === event.value)
        if (getBatch) {
            const futureDates = calculateWeeklyDates(getBatch.start_training_date, 9);
            setTotalWeeks(futureDates);
            setPredefinedWeekForTodaysDate(futureDates)
        }

        setSelectedBatch(event);
        setDisableSelectWeek(false);
    }

    const changePartnerData = (event) => {
        setSelectedBatch(null);
        setCandidateList([]);
        setSelectedPartner(event)
        setSelectedPartnerId(event.value)
        setBatchElementDisabled(false);
    }

    const renderPhotoUploadOrViewIcon = (findDate, weekIndex, date) => {
        const partnerData = findDate.attendance_photo_url.find(
            p => p.partner_id === selectedPartnerId
        );

        if (!partnerData) {
            return (
                <label
                    htmlFor={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-new`}
                    title={`Upload New Photo`}
                >
                    <i className={`${IMPORT_ICON} brand-color attendance-table-icon-font`} />
                    <input
                        type="file"
                        accept="image/*"
                        ref={hiddenFileInput}
                        id={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-new`}
                        style={{ display: 'none' }}
                        onChange={(event) =>
                            uploadAttendancePhotoForAdmin(event, {
                                partner_id: selectedPartnerId,
                                batch: [],
                            }, date)
                        }
                        disabled={findDate.disabled}
                    />
                </label>
            );
        }

        const batchArray = partnerData.batch || [];

        if (batchArray.length === 0) {
            return (
                <label
                    htmlFor={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-new`}
                    title={`Upload New Photo`}
                >
                    <i className={`${IMPORT_ICON} brand-color attendance-table-icon-font`} />
                    <input
                        type="file"
                        accept="image/*"
                        ref={hiddenFileInput}
                        id={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-new`}
                        style={{ display: 'none' }}
                        onChange={(event) =>
                            uploadAttendancePhotoForAdmin(event, {
                                partner_id: selectedPartnerId,
                                batch: [],
                            }, date)
                        }
                        disabled={findDate.disabled}
                    />
                </label>
            );
        }

        const currentBatch = batchArray.find(b => b.batch === Number(selectedBatch?.value));

        if (!currentBatch) {
            return (
                <label
                    htmlFor={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-${selectedBatch?.value}`}
                    title={`Upload Photo for Batch ${selectedBatch?.value}`}
                >
                    <i className={`${IMPORT_ICON} brand-color attendance-table-icon-font ml-2`} />
                    <input
                        type="file"
                        accept="image/*"
                        ref={hiddenFileInput}
                        id={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-${selectedBatch?.value}`}
                        style={{ display: 'none' }}
                        onChange={(event) =>
                            uploadAttendancePhotoForAdmin(event, {
                                partner_id: selectedPartnerId,
                                batch: batchArray,
                            }, date)
                        }
                        disabled={findDate.disabled}
                    />
                </label>
            );
        }

        return currentBatch.photo_url ? (
            <i
                className={`${PICTURE_ICON} list-table-icon cursor-pointer ml-2`}
                onClick={(event) => handleViewAttendancePhoto(event, currentBatch.photo_url)}
                title={`View Photo - Batch ${currentBatch.batch}`}
            />
        ) : (
            <label
                htmlFor={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-${currentBatch.batch}`}
                title={`Upload Photo for Batch ${currentBatch.batch}`}
            >
                {currentBatch.loading ? (
                    <i className={`${LOADING_SPIN} brand-color`} />
                ) : (
                    <i className={`${IMPORT_ICON} brand-color attendance-table-icon-font ml-2`} />
                )}
                <input
                    type="file"
                    accept="image/*"
                    ref={hiddenFileInput}
                    id={`upload-attendance-photo-${weekIndex}-${selectedPartnerId}-${currentBatch.batch}`}
                    style={{ display: 'none' }}
                    onChange={(event) =>
                        uploadAttendancePhotoForAdmin(event, {
                            partner_id: selectedPartnerId,
                            batch: [currentBatch],
                        }, date)
                    }
                    disabled={findDate.disabled || currentBatch.loading}
                />
            </label>
        );
    };

    const formatTo12Hour = (timeString) => {
        if (!timeString) return "-";

        const [h, m] = timeString.split(":").map(Number);
        let hours = h % 12 || 12;
        const minutes = m.toString().padStart(2, "0");
        const period = h >= 12 ? "PM" : "AM";

        return `${hours}:${minutes} ${period}`;
    };

    const handleTrainingComplete = async () => {
        if (window.confirm("Are you sure you want to mark this training as complete?")) {
            try {
                setTrainingCompleteLoading(true);
                await trainingCompleteCall({}, {
                    partner_id: selectedPartnerId,
                    batch: selectedBatch.value,
                    candidatesIds: candidateList.map(item => item._id)
                }, selectedProgram.value);
                ShowToast('Training marked as complete', TYPE_SUCCESS, INTERVAL, null, "");
                fetchProjectList();
                setTrainingCompleteButton("Training Completed");
            } catch (error) {
                console.log("Error occurred while marking training complete", error);
                ShowToast('Failed to mark training complete', TYPE_FAIL, INTERVAL, null, "");
            } finally {
                setTrainingCompleteLoading(false);
            }
        }
    };

    useEffect(() => {
        // Training Completed Button Status Check
        if (selectedBatch) {
            const batchNumber = Number(selectedBatch.value);
            const selectedProgramData = projectListData.find((findItem) => findItem._id === selectedProgram?.value);
            const partnerBatchData = selectedProgramData?.partner_batch_data?.find((item) => item.partner_id === selectedPartnerId);
            const getBatch = partnerBatchData?.training_batches?.find((findBatch) => findBatch.batch === batchNumber);

            if (getBatch && getBatch.training_completed === true) {
                setTrainingCompleteButton("Training Completed");

            } else {
                setTrainingCompleteButton("Mark Training Complete");
            }
        }
    }, [selectedBatch, selectedProgram, selectedPartnerId, projectListData]);

    return (
        <>
            {!loadingComplete ? (
                <Spinner />
            ) : (
                <div className="main-content">
                    <div className="list-wrapper">
                        {projectListData.length > 0 ? (<>
                            <div className="create-program-outer-div">
                                <div className="height-100">
                                    <div className="row">
                                        <div className="col-md-6"></div>
                                        <div className="col-md-6">
                                            {selectedBatch && (
                                                trainingCompleteLoading ? (
                                                    <i className={`${LOADING_SPIN} brand-color`} />
                                                ) : (
                                                    <button
                                                        className="brand-button training-comp-btn"
                                                        onClick={handleTrainingComplete}
                                                        disabled={trainingCompleteLoading || trainingCompleteButton === "Training Completed"}
                                                    >
                                                        {trainingCompleteButton}
                                                    </button>
                                                )
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-wrap">
                                                <label className="form-label-outside" htmlFor="general-information-skills">Project Name</label><span className="text-danger"> *</span>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select Project`}
                                                        value={selectedProgram}
                                                        onChange={(event) => changeProjectName(event)}
                                                        options={projectListComponent}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.selectedProgram}
                                            </div>
                                        </div>
                                        {
                                            adminProfileFlag && (
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="form-label-outside" htmlFor="general-information-skills">Select Training Partner</label><span className="text-danger"> *</span>
                                                        <div className="form-wrap-inner">
                                                            <Select
                                                                placeholder={`Select Training Partner`}
                                                                value={selectedPartner}
                                                                onChange={(event) => changePartnerData(event)}
                                                                options={partnerListComponent}
                                                                isSearchable={true}
                                                                isMulti={false}
                                                                isDisabled={batchElementDisabled}
                                                            />
                                                        </div>
                                                    </div>
                                                    </div>  
                                            )
                                        }
                                        <div className={`col-md-6 ${adminProfileFlag && "mt-2"}`}>
                                            <div className="form-wrap">
                                                <label className="form-label-outside" htmlFor="general-information-skills">Select Batch</label><span className="text-danger"> *</span>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select Batch`}
                                                        value={selectedBatch}
                                                        onChange={(event) => changeBatch(event)}
                                                        options={batchList}
                                                        isSearchable={false}
                                                        isMulti={false}
                                                        isDisabled={batchElementDisabled}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.selectedBatch}
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className="form-wrap">
                                                <label className="form-label-outside" htmlFor="general-information-skills">Select Week</label><span className="text-danger"> *</span>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder={`Select Week`}
                                                        value={selectedWeek}
                                                        onChange={(event) => changeWeekHandler(event)}
                                                        options={weekComponentList}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                        isDisabled={disableSelectWeek}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-danger error-msg">
                                                {error.selectedWeek}
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </div>
                            {
                                isCandidateLoading ?(<Spinner />):(
                                selectedBatch && selectedWeek && !isCandidateLoading && candidateList.length > 0 && (
                                    <div className="attendance-page-table-outer-wrapper attendance-photo-upload-table-wrapper">
                                        {
                                            !isCandidateLoading && candidateList.length > 0 && selectedWeek && (<>
                                                <label>{selectedWeek ? selectedWeek.label : ""}</label>
                                                <table className="attendance-table-table">
                                                    <thead>
                                                        <tr className="program-modal-main-row-header">
                                                            <th className="serial-no-th-width text-center padding-right-0">Sr No</th>
                                                            <th className="width-250px width-responsive-attendance-column padding-left-5">Name</th>
                                                            {
                                                                selectedWeekDates.map((item) => {
                                                                    return (<th className="text-center" key={`dates-coloumn-${item}`}>{item}</th>)
                                                                })
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tr className="table-sub-header">
                                                        <th colspan="9">Upload Daily Photo & Total Candidate Present</th>
                                                    </tr>
                                                    <tbody>
                                                        {
                                                            uploadDailyPhotos.map((listItem, index) => {
                                                                let rowClass = "";
                                                                if (index % 2) {
                                                                    rowClass = "program-modal-row-background-color"
                                                                }
                                                                return (
                                                                    <>
                                                                        {attendanceRows.map((label, index) => (
                                                                            <tr className={rowClass} key={`project-attendance-${index}`}>
                                                                                <td className="text-center">{index + 1}</td>
                                                                                <td className="padding-left-5">{label}</td>

                                                                                {selectedWeekDates.map((item, weekIndex) => {
                                                                                    const findDate = listItem.dateArray.find(findItem => findItem.date === item);
                                                                                    if (!findDate) return <td key={`empty-${weekIndex}`} />;

                                                                                    if (index === 0) {
                                                                                        return (
                                                                                            <td
                                                                                                className={`text-center super-admin-input-td super-admin-daily-upload-td`}
                                                                                                key={`photo-${weekIndex}-${item}`}
                                                                                            >
                                                                                                {renderPhotoUploadOrViewIcon(findDate, weekIndex, item)}
                                                                                                <div className="text-danger error-msg">
                                                                                                    {error.uploadAttendancePhotoError}
                                                                                                </div>
                                                                                            </td>
                                                                                        );
                                                                                    }
                                                                                    if (index === 1) {
                                                                                        return (
                                                                                            <td
                                                                                                className={`text-center ${findDate.disabled ? "opacity-point-four" : ""}`}
                                                                                                key={`present-${weekIndex}`}
                                                                                            >
                                                                                                <input
                                                                                                    type="number"
                                                                                                    name="candidate-present"
                                                                                                    value={calculatePresentCount(item)}
                                                                                                    onChange={(event) => handleCandidatePresent(event, item)}
                                                                                                    disabled={true}
                                                                                                />
                                                                                            </td>
                                                                                        );
                                                                                    }
                                                                                    return (
                                                                                        <td
                                                                                            className={`text-center ${findDate.disabled ? "opacity-point-four" : ""}`}
                                                                                            key={`present-${weekIndex}`}
                                                                                        >
                                                                                            <label className="holiday-reason-label">{renderHolidayReason(findDate)}</label>
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                            </tr>
                                                                        ))}
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                        <tr className="table-sub-header">
                                                            <th colspan="9">Candidate Attendance</th>
                                                        </tr>
                                                        {
                                                            candidateList.map((listItem, index) => {
                                                                let rowClass = "";
                                                                if (index % 2) {
                                                                    rowClass = "program-modal-row-background-color"
                                                                }
                                                                return (
                                                                    <tr className={rowClass} key={`attendance-${listItem._id}`}>
                                                                        <td className="text-center" key={`first-td-${listItem._id}`}>{index + 1}</td>
                                                                        <td className="padding-left-5" key={`second-td-${listItem._id}`}>{listItem.first_name + "  " + listItem.last_name}</td>
                                                                        {
                                                                            listItem.dateArray && listItem.dateArray.length > 0 && (
                                                                                selectedWeekDates.map((item, weekIndex) => {
                                                                                    const findDates = listItem.dateArray.find((findItem) => findItem.date === item);
                                                                                    if (findDates) {
                                                                                        return (
                                                                                            <td className={`text-center ${findDates.disabled ? "opacity-point-four" : ""}`} key={`date-${weekIndex}`} title={findDates.disabled ? "This field is disabled" : ""}>{
                                                                                                <Select
                                                                                                    placeholder={`Select`}
                                                                                                    value={findDates.selectedDate}
                                                                                                    onChange={(event) => handleAttendanceStatus(event, item, listItem._id)}
                                                                                                    options={attendanceTypeComponent}
                                                                                                    isSearchable={false}
                                                                                                    isMulti={false}
                                                                                                    styles={customStyles(findDates.selectedDate?.value)}
                                                                                                    menuPortalTarget={document.body}
                                                                                                    isDisabled={findDates.disabled}
                                                                                                />}
                                                                                                {
                                                                                                    <div className="attendance-time-div">
                                                                                                        {
                                                                                                            findDates.in_time && findDates.status === "present" ? (
                                                                                                                <div key={`select-${weekIndex}`}>
                                                                                                                    {
                                                                                                                        <>
                                                                                                                            <strong><i className={CLOCK} /></strong>
                                                                                                                            {" "}
                                                                                                                            {formatTo12Hour(findDates.in_time)}
                                                                                                                            {
                                                                                                                                findDates.out_time && (
                                                                                                                                    <>
                                                                                                                                        {" - "}
                                                                                                                                        {formatTo12Hour(findDates.out_time)}
                                                                                                                                    </>
                                                                                                                                )
                                                                                                                            }

                                                                                                                        </>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <div key={`select-${weekIndex}`}>-</div>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                }
                                                                                            </td>)
                                                                                    }
                                                                                    else {
                                                                                        return (<> </>);
                                                                                    }
                                                                                })
                                                                            )
                                                                        }
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody >
                                                </table></>)
                                        }
                                    </div>
                                )
                                )
                            }
                            {
                                !isCandidateLoading && (
                                    <div className="form-button-div padding-top20">
                                        {
                                            submitLoading === true ? (
                                                <i className={`${LOADING_SPIN} brand-color`} />
                                            ) : (
                                                hideSubmitButton !== true && candidateList.length > 0 && (
                                                    <button className="brand-button" onClick={handleSubmitClick}>Submit </button>
                                                )
                                            )
                                        }
                                    </div>
                                )
                            }
                        </>
                        ) : (
                            <p>No projects found.</p>
                        )}
                    </div>
                </div>
            )}
            <HolidayReasonPopup modelOpen={showHolidayReasonPopup} closeModel={cancelHandle} updateHolidayReason = {updateHolidayReason}/>
        </>
    );
};

export default AttendanceModulePage;